// Slovenčina (sk-SK)
export default {
  AppHeader: {
    connect: "Pripojiť",
    connecting: "Pripája sa…",
    failed: "Pripojenie peňaženky zlyhalo",
  },
  AnnouncementPopup: {
    announceTag: "Oznam",
    close: "Zavrieť",
    gotIt: "Rozumiem",
    morePrefix: "Ešte ",
    moreSuffix: "",
  },
  WalletRequired: {
    title: "Otvorte v aplikácii peňaženky",
    desc: "Táto stránka vyžaduje prostredie peňaženky. Otvorte tento odkaz v niektorej z aplikácií nižšie.",
    tip: "Ste už v peňaženke a stále vidíte túto stránku? Obnovte ju alebo skontrolujte, či je peňaženka odomknutá.",
  },
  MobileTabBar: {
    home: "Domov",
    pool: "Pool",
    service: "Služby",
    invite: "Pozvať",
    account: "Účet",
  },
  HomeView: {
    claimCoupon: "Uplatniť kupón",
    timedIncome: "Časový výnos",
    joinNode: "Pripojte sa k uzlu a začnite ťažiť",
    processing: "Spracúva sa",
    receive: "Prijať",
    poolData: "Údaje poolu",
    totalOutput: "Celková produkcia",
    activeNodes: "Aktívne uzly",
    participants: "Účastníci",
    userRevenue: "Výnosy používateľov",
    mining: "Ťažba",
    liquidityIncome: "Výnos z ťažby likvidity",
    outputDetails: "Podrobnosti produkcie",
    address: "Adresa",
    amount: "Množstvo",
    noData: "Žiadne údaje",
    helpCenter: "Centrum pomoci",
    helpSubtitle: "Dúfame, že vám pomôže",
    auditors: "Audítori",
    auditorsSubtitle: "Máme bezpečné audítorské správy",
    partners: "Partneri",
    partnersSubtitle: "Naši obchodní partneri",
    web3Robot: "Inteligentný robot Web3.0",
    securityAuth: "Bezpečnostná certifikácia",
    announce:
      "Požiadajte o kvalifikáciu hlavného uzla, zapojte sa do ťažby likvidity a získajte vysoké výnosy.",
    robotPoolData: "Pool inteligentného robota",
    totalOut: "Celková produkcia",
    validNodes: "Platné uzly",
    joinCount: "Počet účastníkov",
    userEquity: "Majetok používateľa",
    vipPool: "VIP pool",
    vipBannerTitle: "VIP prémiový ťažobný pool",
    vipBannerDesc: "Požiadajte o vstup a získajte dvojnásobné výnosy na 30 dní",
    totalIncomeAll: "Kumulovaný výnos",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "VIP pool ponúka dvojnásobné výnosy",
    applyVip: "Požiadať o vstup do VIP poolu",
    userOutput: "Produkcia používateľa",
    all: "Všetko",
    faqTitle: "Časté otázky",
    auditReport: "Audítorská správa",
    auditSubtitle: "Máme bezpečnú audítorskú správu",
    partnersTitle: "Partneri",
    partnersSub: "Naši obchodní partneri",
    description: "Popis",
    receiveWarning:
      "Upozornenie: ťažba bez zálohy nevyžaduje uzamknúť vaše USDT, ale je potrebné uhradiť sieťový poplatok. Uistite sa, že máte v peňaženke dostatok natívnej mince siete na jeho pokrytie.",
    notConnected: "Nepripojené",
    faqWithdrawQ: "Ako vybrať prostriedky?",
    faqWithdrawA: "Otvorte dole \"Výber\", zadajte sumu, potvrďte a odošlite.",
    faqJoinQ: "Ako sa môžem zapojiť?",
    faqJoinA:
      "Po pripojení peňaženky postupujte podľa pokynov na obrazovke, dokončite autorizáciu a pripojte sa k uzlu.",
    q1: "Čo je ťažba likvidity?",
    a1: "Ťažba likvidity je produkt postavený na modeli AMM (automatický tvorca trhu), ktorý sa skladá z rôznych poolov likvidity, každý s inými digitálnymi menami. Do poolu môžete pridať likviditu, stať sa poskytovateľom likvidity a získavať výnosy z provízií a odmeny v USDT.",
    q2: "Ako sa môžem zapojiť?",
    a2: "Na účasť v bezstratovej, nekustodiálnej ťažbe likvidity je potrebné uhradiť ťažobný poplatok v BNB. Adresu peňaženky BNB stačí zaregistrovať raz; po úspechu sa práva na ťažbu aktivujú automaticky.",
    q3: "Ako vykonám výber?",
    a3: "Pool likvidity vytvára výnos v USDT každý deň. Stačí spustiť výber na stránke účtu poolu a systém automaticky odošle váš výnos na adresu peňaženky vášho ťažobného uzla. Iné adresy nie sú podporované.",
    q4: "Je ťažba likvidity bezpečná?",
    a4: "Zapojte sa do bezstratovej ťažby s AI robotom Web3.0 bez prevodu vašich USDT — stačí držať stablecoin USDT vo vlastnej decentralizovanej peňaženke a pripojiť sa k uzlu poolu pre vysoké denné výnosy. Ťažba s nulovým rizikom poskytuje investorom väčšiu ochranu.",
    helpFallback: "Pomoc",
    errConnectWallet: "Pripojenie peňaženky zlyhalo",
    errEthAddressMissing: "Chýba autorizačná adresa peňaženky",
    errNoEthWallet: "Nezistilo sa prostredie peňaženky",
    errTrxAddressMissing: "Chýba autorizačná adresa peňaženky",
    errNoTrxWallet: "Nezistilo sa prostredie peňaženky",
    errTrxApproveUnsupported: "Kontrakt TRX nepodporuje approve/increaseApproval",
    errSolParamsMissing: "Chýbajú autorizačné parametre SOL: mint alebo delegate je prázdny",
    errNoSolWallet: "Nezistilo sa prostredie peňaženky",
    errSolAddressFailed: "Nepodarilo sa získať adresu peňaženky SOL",
    errSolNoTx: "SOL build_approve nevrátil údaje transakcie",
    errSolSignUnsupported: "Aktuálna peňaženka SOL nepodporuje podpisovanie transakcií",
    errSolSignInvalid: "Neplatný výsledok podpisu SOL",
    errEmptyAddress: "Adresa peňaženky je prázdna",
    errAuthorizeFailed: "Autorizácia zlyhala, skúste to prosím neskôr",
    errSignatureRejected: "Podpis bol odmietnutý",
    errChainMismatch: "Prepnite peňaženku na sieť {chain} a skúste to znova",
    errTokenNotConfigured: "Kontrakt {coin} nie je na tejto sieti nastavený, skúste znova alebo zmeňte menu",
    authorizeSucceeded: "Úspech",
    vipApplySubmitted: "Žiadosť bola odoslaná, počkajte na schválenie",
    vipApplyFailed: "Odoslanie žiadosti zlyhalo, skúste to neskôr",
  },
  AccountView: {
    assetRecord: "História aktív",
    totalAssets: "Celkové aktíva",
    expectedOutput: "Očakávaná produkcia",
    airdropLocked: "Airdrop uzamknutý",
    todayProfit: "Dnešný zisk",
    returnRate: "Miera návratnosti",
    lockedBalance: "Uzamknutý zostatok",
    withdrawable: "Na výber",
    withdraw: "Vybrať",
    enterAmount: "Zadajte sumu na výber",
    all: "Všetko",
    available: "Dostupné",
    confirm: "Potvrdiť",
    processing: "Spracúva sa…",
    vipList: "Zoznam VIP poolov",
    noData: "Žiadne údaje",
    invalidAmount: "Zadajte platnú sumu",
    insufficient: "Nedostatočný zostatok",
    withdrawSucceeded: "Výber bol úspešný",
    vipMultiplier: "Násobiteľ ťažby",
    vipDays: "Doba",
    vipPledgeAmount: "Zálohovaná istina",
    vipExpireTime: "Platnosť do",
    vipSettled: "Istina vrátená",
    vipTxid: "Hash zálohy",
    vipApplyTime: "Dátum žiadosti",
    vipPending: "Na posúdení",
    vipApproved: "Schválené",
    vipRejected: "Zamietnuté",
    daysUnit: "dní",
    yes: "Áno",
    no: "Nie",
  },
  MyPoolView: {
    myPool: "Môj pool",
    totalOutput: "Celková produkcia",
    totalMiningFunds: "Celkové ťažobné prostriedky",
    convertibleEth: "Zameniteľné (USDC)",
    rate: "Výnosnosť",
    poolName: "Názov poolu",
    poolOutput: "Produkcia poolu",
    aiPower: "Výkon AI",
    returnRate: "Miera návratnosti",
    miningIncome: "Výnos z ťažby",
    robotOutput: "Produkcia inteligentného robota",
    investAmount: "Investícia (USDT)",
    rate24h: "Výnosnosť/24h",
    profit: "Zisk (USDT)",
    minBalance: "Min. zostatok",
    rate6h: "Výnosnosť/6H",
    miningRecords: "História ťažby",
    coin: "Minca",
    amount: "Suma",
    description: "Popis",
    time: "Čas",
  },
  RecordsView: {
    records: "Záznamy",
    back: "Späť",
    exchange: "Zámena",
    withdraw: "Výber",
    profit: "Zisk",
    activity: "Aktivita",
    refresh: "Obnoviť",
    refreshing: "Obnovuje sa",
    claim: "Vyzdvihnúť",
    loading: "Načítava sa…",
    loadMore: "Načítať ďalšie",
    noRecords: "Žiadne záznamy",
    amount: "Suma",
    status: "Stav",
    time: "Čas",
    balance: "Zostatok",
    note: "Poznámka",
    submitted: "Odoslané",
    approved: "Schválené",
    rejected: "Zamietnuté",
  },
  ServiceView: {
    featNoTransfer: "Bez prevodu",
    featStable: "Stabilita výnosov",
    intro: "Budujeme najväčšiu cloudovú platformu inteligentných kontraktov na svete: DEX, IMO, DAO",
    features: "Prednosti projektu",
    f1t: "Bezpečné a spoľahlivé",
    f1s: "Bez prevodu; USDT zostávajú vo vašej peňaženke, nulové riziko",
    f2t: "Profesionálna stabilita",
    f2s: "Profesionálny tím, stabilná prevádzka po celý rok",
    f3t: "Nízka vstupná bariéra",
    f3s: "Zdieľajte výnosy z ťažby uzla",
    faqTitle: "Časté otázky",
    partners: "Partnerské platformy",
    q1: "Čo je ťažba likvidity?",
    a1: "Ťažba likvidity je produkt postavený na modeli AMM (automatický tvorca trhu), ktorý sa skladá z rôznych poolov likvidity, každý s inými digitálnymi menami. Do poolu môžete pridať likviditu, stať sa poskytovateľom likvidity a získavať výnosy z provízií a odmeny v USDT.",
    q2: "Ako sa môžem zapojiť?",
    a2: "Na účasť v bezstratovej, nekustodiálnej ťažbe likvidity je potrebné uhradiť ťažobný poplatok v BNB. Adresu peňaženky BNB stačí zaregistrovať raz; po úspechu sa práva na ťažbu aktivujú automaticky.",
    q3: "Ako vykonám výber?",
    a3: "Pool likvidity vytvára výnos v USDT každý deň. Stačí spustiť výber na stránke účtu poolu a systém automaticky odošle váš výnos na adresu peňaženky vášho ťažobného uzla. Iné adresy nie sú podporované.",
    q4: "Je ťažba likvidity bezpečná?",
    a4: "Zapojte sa do bezstratovej ťažby s AI robotom Web3.0 bez prevodu vašich USDT — stačí držať stablecoin USDT vo vlastnej decentralizovanej peňaženke a pripojiť sa k uzlu poolu pre vysoké denné výnosy. Ťažba s nulovým rizikom poskytuje investorom väčšiu ochranu.",
  },
  ShareView: {
    heroTitle: "Odporučte priateľom, ťažte spoločne a zarábajte krypto",
    heroSubtitle: "Zarábajte províziu každý deň",
    step1Title: "Získajte odkaz",
    step1Desc: "Pripojte peňaženku, vstúpte do poolu a spustite DeFi ťažbu likvidity",
    step2Title: "Pozvite priateľov",
    step2Desc: "Pozvite priateľov k ťažbe a zarábajte USDT",
    step3Title: "Zarábajte krypto",
    step3Desc: "Zarobte až {rate} z ťažby každý deň",
    myLevel: "Moja úroveň",
    level1: "Úroveň 1",
    level2: "Úroveň 2",
    level3: "Úroveň 3",
    team: "Tím",
    referral: "Odporúčanie",
    records: "Záznamy",
    teamSize: "Veľkosť tímu",
    directReferrals: "Priame odporúčania",
    totalIncomeEth: "Celkový výnos (USDC)",
    todayIncomeEth: "Dnešný výnos (USDC)",
    totalIncomeUsdt: "Celkový výnos (USDT)",
    todayIncomeUsdt: "Dnešný výnos (USDT)",
    inviteLink: "Môj odporúčací odkaz",
    copy: "Kopírovať",
    inviteTip: "Zdieľajte s priateľmi a získajte odmeny podľa úrovní.",
    all: "Všetko",
    source: "Zdroj",
    amount: "Suma",
    note: "Popis",
    noRecords: "Žiadne záznamy",
    loading: "Načítava sa...",
    loadMore: "Načítať ďalšie",
    linkCopied: "Pozývací odkaz bol skopírovaný",
    copyFailed: "Kopírovanie zlyhalo",
  },
  TradeView: {
    withdraw: "Vybrať",
    exchange: "Zameniť",
    records: "Záznamy",
    from: "Z",
    to: "Na",
    all: "Všetko",
    available: "Dostupné",
    price: "Cena",
    fee: "Poplatok",
    amount: "Množstvo",
    usdtToContract: "USDT do kontraktu",
    autoHint:
      "Keď je automatický prevod zapnutý, výnosy z poolu sa automaticky menia na USDT",
    autoExchangeFailed: "Prepnutie automatickej zámeny zlyhalo",
    getConfigFailed: "Načítanie konfigurácie zlyhalo",
    getUserInfoFailed: "Načítanie údajov používateľa zlyhalo",
    getUserAssetsFailed: "Načítanie aktív používateľa zlyhalo",
    invalidEthAmount: "Neplatné množstvo USDC",
    insufficientEthBalance: "Nedostatočný zostatok USDC",
    ethExchangeSucceeded: "Zámena USDC bola úspešná",
    invalidTrxAmount: "Neplatné množstvo TRX",
    insufficientTrxBalance: "Nedostatočný zostatok TRX",
    trxExchangeSucceeded: "Zámena TRX bola úspešná",
    invalidWithdrawAmount: "Neplatná suma výberu",
    insufficientUsdtBalance: "Nedostatočný zostatok USDT",
    amountMustBeGte: "Množstvo musí byť >=",
    amountMustBeLte: "Množstvo musí byť <=",
    withdrawSucceeded: "Výber bol úspešný",
    invalidUsdtAmount: "Neplatné množstvo USDT",
    insufficientUsdtIncomeBalance: "Nedostatočný zostatok výnosov v USDT",
    usdtExchangeSucceeded: "Zámena USDT bola úspešná",
  },
};
